/**
 * Platform branding — single source of truth for the hub chrome + login.
 *
 * Change these to rebrand the product. (Working name "EJT Event Platform"
 * for now.) Kept here so a future white-label / per-tenant brand can swap it
 * in one place.
 */
export const BRAND = {
  /** Primary product name shown in the sidebar / header / login. */
  name: 'EJTHub',
  /** Short tagline under the name. */
  tagline: 'Connected event services',
  /** Logo asset path (served from /public). */
  logo: '/KDULogo.PNG',
  /**
   * Wide horizontal lockup (contains the EJTHub wordmark). Use this where the
   * logo stands alone as the brand on a LIGHT background (e.g. login) — render
   * it WITHOUT adjacent brand text, since the wordmark is already in the image.
   */
  lockup: '/ejthub-logo.png',
  /**
   * White knockout of the lockup (tagline removed) for DARK surfaces — the
   * sidebar, mobile header, and nav drawer. Sits directly on the dark green
   * with no card behind it.
   */
  lockupWhite: '/ejthub-logo-white.png',
  /** Just the circular people-mark, white (for dark surfaces). ~1:1. */
  markWhite: '/ejthub-mark-white.png',
  /** Just the circular people-mark, full color (for light surfaces). */
  mark: '/ejthub-mark.png',
  /** Public marketing site — the brand logo links here (opens a new tab). */
  marketingUrl: 'https://ejthub.com',
};
